import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Col } from 'react-flexbox-grid';

import { title } from './DocumentTitle.less';

const DocumentTitle = ({ localeId, infoElement }) => (
  <h3 className={title}>
    <Row middle="xs">
      <Col xs>
        <FormattedMessage id={localeId} />
        {infoElement && infoElement}
      </Col>
    </Row>
  </h3>
);

DocumentTitle.propTypes = {
  localeId: PropTypes.string,
  infoElement: PropTypes.node,
};

export default DocumentTitle;
